export default function Navbar() {
  return (
    <div className="navbar">
      <h2>Medilink</h2>
    </div>
  );
}
